'use client'

import { searchVisibleAtom } from '@/app/[locale]/(search)/search/characters/_state/search-visibility'
import { CharacterSearchInput } from '@/features/character-search/layout/searc-input'
import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'

export default function SearchBarClient() {
  const headerVisible = useAtomValue(searchVisibleAtom)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!headerVisible) setVisible(true)
    else {
      // delay unmount for animation
      const timeout = setTimeout(() => setVisible(false), 300)
      return () => clearTimeout(timeout)
    }
  }, [headerVisible])

  return (
    <div
      className={`transition-all duration-300 ${
        headerVisible
          ? 'translate-x-[-20px] opacity-0'
          : 'translate-x-0 opacity-100'
      }`}>
      {visible && (
        <CharacterSearchInput
          inSearchPage
          inHeader
          variant={'sm'}
          className="w-373 max-lg:hidden [&_input]:min-w-0"
        />
      )}
    </div>
  )
}
